export default {
    bookingsOrders: [],
    bookingsRequests: [],
}